export const CONSENT_LABELS = {
  unknown: 'Toestemming onbekend',
  granted: 'Toestemming gegeven',
  withdrawn: 'Toestemming ingetrokken',
};

export const KIND_LABELS = { user: 'Zoea-gebruiker', manual: 'Extern' };

export const STATUS_FILTERS = [
  ['alle', 'Alle'],
  ['actief', 'Actief'],
  ['inactief', 'Inactief'],
];

export const filterRecipients = (recipients, { status = 'alle', search = '' } = {}) => {
  const needle = search.trim().toLowerCase();
  return recipients.filter((recipient) => {
    if (status === 'actief' && !recipient.is_active) return false;
    if (status === 'inactief' && recipient.is_active) return false;
    if (!needle) return true;
    return [recipient.name, recipient.email, ...(recipient.groups || []).map((group) => group.name)]
      .filter(Boolean).join(' ').toLowerCase().includes(needle);
  });
};

export const SKIP_REASONS = {
  not_found: 'niet gevonden of niet actief',
  already_listed: 'staat al op de lijst',
  email_already_listed: 'e-mailadres staat al als externe ontvanger op de lijst',
};

export const summarizeAddResult = ({ created = [], skipped = [] }) => {
  const parts = [`${created.length} toegevoegd`];
  if (skipped.length) parts.push(`${skipped.length} overgeslagen`);
  return parts.join(', ');
};

export const errorText = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return error?.response?.status === 403 ? 'Je hebt geen rechten om ontvangers te beheren.' : fallback;
};
